<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yCHHgW/tc-custom/9781466827745.jpg?1724535926133" alt="This image is the cover for the book Counting One's Blessings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Counting One's Blessings
      </h1>
      <p class="bookDescription body article font2">
        <p>William Shawcross's official biography of Queen Elizabeth the Queen Mother, published in September 2009, was a huge critical and commercial success.One of the great revelations of the book was Queen Elizabeth's insightful, witty private correspondence. Indeed, <i>The Sunday Times</i> described her letters as "wonderful . . . brimful of liveliness and irreverence, steeliness and sweetness."<br/><br/>Now, in <i>Counting One's Blessings</i>, Shawcross has put together a selection of her letters, drawing on the vast wealth of material in the Royal Archives and at Glamis Castle. Queen Elizabeth was a prolific correspondent, from her early childhood before World War I to the very end of her long life at the beginning of the twenty-first century, and her letters offer readers a vivid insight into the real person behind the public face.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Shawcross
      </h2>
      
      <p class="authorDescription body article"><B>William Shawcross</B> became a writer after leaving University College Oxford in 1968. He was in Czechoslovakia during the Soviet occupation; this inspired his first book, a biography of Alexander Dubcek, the Czechoslovak leader, which was published in 1970. Since then he has written and travelled widely. In 1995 he wrote the BBC Television series <I>Monarchy</I>. In 2002 his BBC Television series and book, <I>Queen and Country</I>, celebrated the Queen's Golden Jubilee and examined the changing face of Britain during her reign. He is also the author of <I>Justice and the Enemy: Nuremberg, 9/11 and the Trial of Khalid Sheikh Mohammed</I> (2012). He lives in England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7d2fb6e